import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { initTvMode } from './utils/tvMode'

// Detect Fire TV / ?tv=1 before first paint so TV CSS applies immediately.
initTvMode()

const container = document.getElementById('root')

if (container) {
  const root = ReactDOM.createRoot(container)
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
} else {
  console.error('Root container not found')
}
